import { Controller } from '@hotwired/stimulus'
import {AwsS3Multipart, Core, Dashboard} from 'uppy'
import {headers} from '../../src/js/csrf'
import '../../src/css/modules/uppy.scss'

export default class extends Controller {
  static targets = [ 'attachment', 'attachments' ]

  initialize() {
    this.initUppy()
  }

  initUppy() {
    this.uppy = Core({
      autoProceed: true,
      restrictions: {
        // 3Mb - 4.5Gb
        minFileSize: 3_145_728,
        maxFileSize: 4_831_838_208,
        maxNumberOfFiles: 3,
        allowedFileTypes: ['video/*']
      },
    })
      .use(AwsS3Multipart, {
        companionUrl: '/',
      })
      .use(Dashboard, {
        proudlyDisplayPoweredByUppy: false,
        closeAfterFinish: true
      })

    this.uppy.on('upload-success', this.uploadSuccess.bind(this))
  }

  // action
  openDashboard() {
    // 3 files specified in uppy options is only for parallel submission
    // so we still need to check amount of uploads
    if (!this.hasAttachmentTarget || this.attachmentTargets.length < 3) {
      this.uppy.getPlugin('Dashboard').openModal()
    } else {
      const toastEvent = new CustomEvent('toast:show', {detail: {
          message: '3 files maximum',
          type: 'warning'
        }})
      window.dispatchEvent(toastEvent)
    }
  }

  uploadSuccess(file, response) {
    const fileData = {
      id: response.uploadURL.match(/\/cache\/([^\?]+)/)[1], // extract key without prefix
      storage: 'cache',
      metadata: {
        size:      file.size,
        filename:  file.name,
        mime_type: file.type,
      }
    }
    fetch(this.data.get('path'), {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        offer_video: {
          video: fileData
        }
      })
    }).then(response => {
      if (!response.ok) throw response
      return response.json()
    }).then(res => {
      this.attachmentsTarget.insertAdjacentHTML('afterbegin', res.html)
    }).catch(err => {
      err.json().then(body => console.error('we got an error: ', body.message))
    })
  }

}
